/**
 * Time period before the expiration time at which the token should already be updated.
 */
export const TOKEN_REFRESH_LEAD_TIME = 60 * 1000; // 1 Minute

/**
 * Time period after a failed update when another attempt should be made.
 */
export const TOKEN_REFRESH_RETRY_TIME = 10 * 1000; // 10 Seconds

/**
 * Time period before the expiration time at which the token is already considered expired.
 */
export const TOKEN_EXPIRED_LEAD_TIME = 10 * 1000; // 10 Seconds
